export default "__VITE_ASSET__CUOdL1jJ__"